import { useMemo } from 'react';
import { FieldType, SourceType } from 'components/organisms/tasks/fields';
import { useIsCurrentUserPartner } from 'hooks/use-partner';
import { useTranslation } from 'hooks/use-translation';
import { useGetAllPartnerCompanies } from 'queries/partner';
import { byLabel } from 'utils/comparators/by-label';
import { getRandomColor } from '../get-random-color';
export const usePartnerCompanyField = (fieldId)=>{
    var _ref;
    const { data: companies, isLoading, isInitialLoading } = useGetAllPartnerCompanies();
    const fieldLabel = useTranslation('partners');
    const isAnyPartnerCompanyAvailable = ((_ref = companies === null || companies === void 0 ? void 0 : companies.length) !== null && _ref !== void 0 ? _ref : 0) > 0;
    const isCurrentUserPartner = useIsCurrentUserPartner();
    return useMemo(()=>({
            partnerCompaniesField: {
                fieldId,
                fieldName: 'partnerCompany',
                fieldLabel,
                type: FieldType.MultiSelect,
                customField: false,
                private: false,
                metaData: {
                    options: (companies !== null && companies !== void 0 ? companies : []).map((company)=>({
                            label: company.active ? company.companyName : `${company.companyName} (Deactivated)`,
                            value: company.companyId,
                            imageUrl: company.companyLogoUrl,
                            active: true,
                            color: getRandomColor(company.companyId)
                        })).sort(byLabel)
                },
                sourceType: SourceType.Project
            },
            isLoading: !isCurrentUserPartner ? isLoading : isInitialLoading,
            isAnyPartnerCompanyAvailable
        }), [
        companies,
        fieldId,
        fieldLabel,
        isAnyPartnerCompanyAvailable,
        isLoading,
        isCurrentUserPartner,
        isInitialLoading
    ]);
};
